import { render, staticRenderFns } from "./EmergencyMessageDialog.vue?vue&type=template&id=3970280e&scoped=true&"
import script from "./EmergencyMessageDialog.vue?vue&type=script&lang=ts&"
export * from "./EmergencyMessageDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EmergencyMessageDialog.vue?vue&type=style&index=0&id=3970280e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3970280e",
  null
  
)

export default component.exports